import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService} from './auth.service'
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
      return this.auth.user
           .take(1)
           .map(user => !!user.isAdmin)
           .do(loggedIn => {
             if (!loggedIn) {
               console.log('admin access denied')
               this.router.navigate(['/login']);
             }
         })
  }
}



// WEBPACK FOOTER //
// ./src/app/core/admin.guard.ts